module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeBag@3x.e1f6a786.png";